import i18n from '@/i18n';

// Causali di annullamento di un ordine. Il `code` è il valore persistito su
// Firestore (campo `cancellation_reason`): stabile e in inglese, mai tradotto —
// le label sono solo UI e passano da i18n. Aggiungere in coda, non rinominare i
// code esistenti (romperebbe lo storico già salvato).
export const CANCELLATION_REASONS = [
  { code: 'customer_request', label: 'Annullamento richiesto dal cliente/utente' },
  { code: 'appointment_cancelled', label: 'Appuntamento o visita annullata/rinviata' },
  {
    code: 'health_status_changed',
    label: 'Ricovero, dimissione o situazione sanitaria modificata',
  },
  { code: 'other_transport', label: 'Trasporto organizzato con altra soluzione' },
  { code: 'booking_error', label: 'Errore di prenotazione / servizio duplicato' },
  { code: 'service_rebooked', label: 'Modifica del servizio con nuova prenotazione' },
  { code: 'user_not_transportable', label: 'Utente non trasportabile / requisiti non compatibili' },
  { code: 'no_show', label: 'No-show / utente non presente' },
  { code: 'mbility_unavailable', label: 'Annullamento per indisponibilità Mbility' },
  { code: 'vehicle_unavailable', label: 'Problema tecnico / mezzo indisponibile' },
  { code: 'force_majeure', label: 'Forza maggiore / causa esterna' },
  { code: 'other', label: 'Altro', requiresNote: true },
];

export const OTHER_CANCELLATION_REASON = 'other';

const byCode = new Map(CANCELLATION_REASONS.map((r) => [r.code, r]));

/** Label localizzata di una causale (chiave i18n `cancellation_reason_<code>`). */
export const getCancellationReasonLabel = (code) => {
  const reason = byCode.get(code);
  if (!reason) return code || '';
  return i18n.t(`cancellation_reason_${code}`, { defaultValue: reason.label });
};

/** True se la causale obbliga a scrivere una nota libera. */
export const cancellationReasonRequiresNote = (code) => byCode.get(code)?.requiresNote === true;

/**
 * Valida la coppia causale/nota come la valida il dialog: nessuna causale → non
 * valido; causale "Altro" senza nota → non valido.
 */
export const isCancellationValid = ({ reason, note } = {}) => {
  if (!reason || !byCode.has(reason)) return false;
  if (cancellationReasonRequiresNote(reason)) return Boolean(note && note.trim());
  return true;
};
